export const AB_TESTING_GROUP = {
  CONTROL: 'control',
  TREATMENT: 'treatment',
  TREATMENT_1: 'treatment1',
  TREATMENT_2: 'treatment2',
  TREATMENT_3: 'treatment3',
  ENABLED: 'enabled',
} as const;

export type AB_TESTING_GROUP =
  (typeof AB_TESTING_GROUP)[keyof typeof AB_TESTING_GROUP];

export type UserExperimentType = {
  experiment: string;
  group: string;
  config: Record<string, string>;
};
